export const LOCATIONS_BY_USER_REST_ENDPOINT = 'api/v1/locations/by_user';
